import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import {TranslateService} from 'ng2-translate';

import { AlertManagerService } from "../../../shared/services/alert-manager.service";
import { ProjectsService } from "../services/projects.service";

import { Sprint } from '../../models/sprint';
import { Constants } from '../../../app.const';

declare var $: any

@Component({
  selector: 'app-modal-sprint-create',
  templateUrl: './modal-sprint-create.component.html',
  providers: [ ProjectsService ]
})
export class ModalSprintCreateComponent implements OnInit {

  @Input() projectId: number;
  @Output() getSprints: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('sprintModal') elementRef:ElementRef;

  sprintCreateForm: FormGroup;
  sprint: Sprint = new Sprint();
  isCreated: boolean = true;
  isSubmitted: boolean = false;
  start_date: any;
  end_date: any;
  private constants = Constants;
  private startDatePickerOptions: IMyOptions = {
      dateFormat: this.constants.dateFormatDatepicker,
      selectionTxtFontSize: '14px',
      editableDateField: false,
      disableUntil: {year: 2016, month: 8, day: 10},
  };

  private endDatePickerOptions: IMyOptions = {
      dateFormat: this.constants.dateFormatDatepicker,
      selectionTxtFontSize: '14px',
      editableDateField: false,
      disableUntil: {year: 2016, month: 8, day: 10},
  };

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertManagerService,
    private projectsService: ProjectsService
  ) { }

  ngOnInit() {
    let currentData = new Date();
    let year = currentData.getFullYear();
    let month = currentData.getMonth()+1;
    let day = currentData.getDate();
    this.startDatePickerOptions.disableUntil.year = year;
    this.startDatePickerOptions.disableUntil.month = month;
    this.startDatePickerOptions.disableUntil.day = day-1;

    this.endDatePickerOptions.disableUntil.year = year;
    this.endDatePickerOptions.disableUntil.month = month;
    this.endDatePickerOptions.disableUntil.day = day;

    this.sprintCreateForm = this.formBuilder.group({
        title: ['', Validators.required],
        start_date: ['', Validators.required],
        end_date: ['', Validators.required],
        working_days: ['', Validators.required],
        description: [ ]
    });
  }

  openSprintModal(sprint: any){
    this.isCreated = true;
    this.isSubmitted = false;
    if(sprint){
      this.sprint.id = sprint.id;
      this.sprint.title = sprint.title;
      this.sprint.description = sprint.description;
      this.sprint.working_days = sprint.working_days;
      this.start_date = this.getDateObject(sprint.start_date);
      this.end_date = this.getDateObject(sprint.end_date);
      this.isCreated = false;
    }else{
      let currentData = new Date();
      let year = currentData.getFullYear();
      let month = currentData.getMonth()+1;
      let day = currentData.getDate();
      this.start_date = {
        date: { year: year, month: month, day: day },
        formatted: year+'-'+month+'-'+day
      };
      currentData.setDate(currentData.getDate()+1);
      this.end_date = {
        date: { year: currentData.getFullYear(), month: currentData.getMonth()+1, day: currentData.getDate() },
        formatted: currentData.getFullYear()+'-'+(currentData.getMonth()+1)+'-'+ currentData.getDate()
      };
    }
  }

  onStartDateChanged(event: IMyDateModel) {
    if(event.date.year+event.date.month+event.date.day !== 0){
      this.endDatePickerOptions.disableUntil.year = event.date.year;
      this.endDatePickerOptions.disableUntil.month = event.date.month;
      this.endDatePickerOptions.disableUntil.day = event.date.day;
      let date = new Date(event.jsdate);
      date.setDate(date.getDate()+1);
      this.end_date = {
        date: { year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate() },
        formatted: date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
      };
    }
  }

  closeSprintModal(){
    this.clearDateField();
  }

  getDateObject(dateValue: string): any {
    let date = new Date(dateValue);
    return {
      date:{
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      },
      formatted: dateValue
    }
  }

  clearDateField(): void {
    let emptyObject = {
      title:'',
      start_date:'',
      end_date:'',
      working_days:'',
      description:''
    }
    this.sprintCreateForm.setValue(emptyObject);
    this.isSubmitted = false;
  }

  doCreateSprint(event){
    this.isSubmitted = true;
    if(this.sprintCreateForm.valid){
      this.sprint.start_date = this.start_date.formatted;
      this.sprint.end_date = this.end_date.formatted;
      if(this.isCreated){
        this.createSprint();
      }else{
        this.updateSprint();
      }
    }
  }

  createSprint(){
    this.projectsService.createSprint(this.projectId, this.sprint).subscribe(
      data => {
        this.clearDateField();
        if(data.status_code == 406){
          $(this.elementRef.nativeElement).modal('hide');
          this.alertService.warning({title: "", msg: data.message});
        }else{
          this.getSprints.emit(true);
          $(this.elementRef.nativeElement).modal('hide');
          this.alertService.success({title: "", msg: "Successfully Created"});
        }
      }
    );
  }

  updateSprint(){
    this.projectsService.updateSprint(this.projectId, this.sprint).subscribe(
      data => {
        if(data.status_code == 406){
          $(this.elementRef.nativeElement).modal('hide');
          this.alertService.warning({title: "", msg: data.message});
        }else{
          this.getSprints.emit(true);
          this.alertService.success({title: "", msg: "Successfully Updated"});
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-sprint-create.component.ts